import { useState } from 'react'

import { CheckPromoCodeResponse } from 'entities/promo-code/model'
import { PromoCode } from 'entities/promo-code/ui/promo-modal'

import { BuyTicketApi } from 'shared/api/BuyTicket'
import { TicketInsurance } from 'shared/api/avia/insurance'
import { getErrorMessage } from 'shared/lib/errorText'
import { TicketItem } from 'shared/models/ticket'

interface Props {
  ticketBookInfo?: {
    selectedTicket: TicketItem | null
    selectedInsurances: TicketInsurance[] | null
  }
  serviceId?: string
  onAppliedPromoCode?: (applieedPromoCode: CheckPromoCodeResponse) => void
}

export const PromoCodeAvia = ({
  serviceId,
  ticketBookInfo,
  onAppliedPromoCode,
}: Props) => {
  const [loading, setLoading] = useState<boolean>(false)

  const [error, setError] = useState<string | undefined>(undefined)

  const onApplyPromoCode = async (promoCode: string) => {
    if (serviceId) {
      onApplyPromoCodeWithService(promoCode)
      return
    }

    if (!ticketBookInfo?.selectedTicket || !ticketBookInfo?.selectedInsurances)
      return

    setLoading(true)

    try {
      setError(undefined)

      const { data: promoCodeResponse } = await BuyTicketApi.checkPromoCode({
        service_type: 'tickets',
        promocode: promoCode || '',
        data: {
          recommendation: ticketBookInfo.selectedTicket,
          insurance_tariffs: ticketBookInfo.selectedInsurances,
        },
      })

      onAppliedPromoCode?.(promoCodeResponse?.data)
    } catch (err) {
      setError(getErrorMessage(err))
    } finally {
      setLoading(false)
    }
  }

  const onApplyPromoCodeWithService = async (promoCode: string) => {
    setLoading(true)

    try {
      setError(undefined)

      const { data: promoCodeResponse } = await BuyTicketApi.checkPromoCode({
        service_type: 'tickets',
        promocode: promoCode || '',
        service_id: serviceId || '',
      })

      onAppliedPromoCode?.(promoCodeResponse?.data)
    } catch (err) {
      setError(getErrorMessage(err))
    } finally {
      setLoading(false)
    }
  }

  return (
    <PromoCode
      error={error}
      isLoading={loading}
      onBookCheckTicket={onApplyPromoCode}
    />
  )
}
